import { ConversionTrackingService } from './services/ConversionTrackingService';
import { ThankYouService } from './services/ThankYouService';
import type { Init } from './types';
import type { MergedDataReturnType, MergedHandlersReturnType } from '../../types';
import { WithApi } from '../WithApi';

export type ThankYouData = MergedDataReturnType<[ThankYouService]>;

export type ThankYouHandlers = MergedHandlersReturnType<[ThankYouService, ConversionTrackingService]>;

type TApi = ReturnType<ThankYouService['api']>;

export class ThankYouManager extends WithApi<TApi> {
  public thankYouInit = ({ t, locationState, version, flags }: Init) => {
    const {
      xeroPartnerTurnedOn,
      isSocialStarter,
      isCurrentPlanEvents,
      hasVerifiedEmail,
      billingEmailId,
      billingEmailAddress,
      soid,
    } = flags;
    const thankYouService = new ThankYouService(
      t,
      xeroPartnerTurnedOn,
      isSocialStarter,
      isCurrentPlanEvents,
      hasVerifiedEmail,
      version,
      locationState?.firstName,
      billingEmailId,
      billingEmailAddress
    );

    // Instantiate conversion tracking service
    const conversionTrackingService = new ConversionTrackingService({
      soid,
      // TODO: Add plan and amount when available from order context
      plan: undefined,
      amount: undefined,
    });

    this.initApi({
      ...thankYouService.api(),
    });

    return {
      status: 'loaded',
      data: {
        ...thankYouService.data(),
      },
      handlers: {
        ...thankYouService.handlers(),
        ...conversionTrackingService.handlers(),
      },
    } as const;
  };
}
